// eslint-disable-next-line no-use-before-define
import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import { MenuV1 } from '../components/menu/v1';
import { MenuV2 } from '../components/menu/v2';
import { Loading, StageLoading } from '../components/loading/';
import { EnvLabel } from '../components/env-label/';
import { Toast } from '../components/toast';
import { useTranslation } from 'react-i18next';
import useLoadNps from '../hook/use-load-nps';
export const LayoutComponent = (props) => {
    const { envLabel, uiVersion, hidden, language, pageTitle, currentMfeState, nps, userData, mfeStage, tenant, userProfile, loading, } = props;
    const { i18n } = useTranslation();
    useLoadNps({
        currentMfeState,
        nps,
        userData,
        mfeStage,
        tenant,
        userProfile,
    });
    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);
    // REMOVER QUANDO V1 FOR DESCOTINUADA
    const resizeIframe = useCallback(() => {
        const iframeWrapper = document.getElementById('root-app_side_content').style;
        const iframeStyle = document.getElementById('root-app_iframe').style;
        if (uiVersion === 'V1') {
            iframeStyle.width = `${window.innerWidth - (hidden ? 0 : 60)}px`;
        }
        let heightToSubtract = envLabel ? 25 : 0;
        heightToSubtract += uiVersion === 'V2' ? 88 : 0;
        const screenHeight = window.innerHeight - heightToSubtract;
        iframeWrapper.height = `${screenHeight}px`;
    }, [uiVersion, envLabel, hidden]);
    // REMOVER QUANDO V1 FOR DESCOTINUADA
    useLayoutEffect(() => {
        const bodyStyle = document.body.style;
        const iframeStyle = document.getElementById('root-app_iframe').style;
        if (uiVersion === 'V1') {
            bodyStyle.overflow = 'hidden';
            iframeStyle.marginLeft = hidden ? '0px' : '60px';
        }
        if (uiVersion === 'V2') {
            iframeStyle.width = '100%';
            iframeStyle.marginLeft = '0px';
        }
    }, [uiVersion, hidden]);
    useLayoutEffect(() => {
        resizeIframe();
        window.onresize = resizeIframe;
        return () => {
            window.onresize = null;
        };
    }, [uiVersion, hidden, envLabel]);
    useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);
    // O splash do index.html cobre a abertura até o React pintar o primeiro
    // quadro; daqui em diante quem mostra o carregamento é o <Loading />.
    useEffect(() => {
        document.getElementById('root-app_splash')?.remove();
    }, []);
    return (React.createElement("div", { className: "root-app_layout" },
        React.createElement(Loading, null),
        React.createElement(StageLoading, null),
        React.createElement(EnvLabel, null),
        React.createElement("div", { className: `root-app_content${loading ? ' root-app_content--loading' : ''}` },
            React.createElement(MenuV1, null),
            React.createElement(MenuV2, null)),
        React.createElement(Toast, null)));
};
//# sourceMappingURL=component.js.map